import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed, defineComponent, ref } from 'vue';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router';
import { useEmptyStringFormat } from '@/hooks/fn';
import useAggregateSaleData from './hooks/useAggregateSaleData';
import useAggregateSaleConstrastData from './hooks/useMortarTrend';
import { PieEchart, BarEchartMul } from '@/components/page-echarts';
import CTypeTab from '@/components/CTypeTab.vue';
import localCache from '@/utils/localCache';
export default defineComponent({
  name: 'AggregateDailySalesReport',
  components: {
    PieEchart: PieEchart,
    BarEchartMul: BarEchartMul,
    CTypeTab: CTypeTab
  },
  setup: function setup() {
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      getAggregateSaleDataAsync();
      getAggregateSaleContrastDataAsync();
      if (params.value.type === 3) {
        getAggregateSaleContrastDataYearAsync();
      }
    };
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              if (val === 4) {
                params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
              } else {
                params.value.date = dayjs().format('YYYY/MM/DD');
              }
              if (val === 3) {
                getAggregateSaleContrastDataYearAsync();
              }
              getAggregateSaleDataAsync();
              getAggregateSaleContrastDataAsync();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var switchClick = function switchClick() {
      if (params.value.type === 0) {
        window.location.href = "/table/shajiangBuyDay.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 1) {
        window.location.href = "/table/shajiangBuyWeek.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 2) {
        window.location.href = "/table/shajiangBuyMonth.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
    };
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据
    });
    var _useAggregateSaleData = useAggregateSaleData(params),
      _useAggregateSaleData2 = _slicedToArray(_useAggregateSaleData, 2),
      aggregateSaleData = _useAggregateSaleData2[0],
      getAggregateSaleDataAsync = _useAggregateSaleData2[1];
    getAggregateSaleDataAsync();
    var _useAggregateSaleCons = useAggregateSaleConstrastData(params),
      _useAggregateSaleCons2 = _slicedToArray(_useAggregateSaleCons, 4),
      aggregateSaleContrastData = _useAggregateSaleCons2[0],
      aggregateSaleContrastYearData = _useAggregateSaleCons2[1],
      getAggregateSaleContrastDataAsync = _useAggregateSaleCons2[2],
      getAggregateSaleContrastDataYearAsync = _useAggregateSaleCons2[3];
    getAggregateSaleContrastDataAsync();
    var emptyStringFormat = useEmptyStringFormat();
    var summaryData = computed(function () {
      return [{
        num: aggregateSaleData.value.totalSettleValue,
        desc: '总进料量/吨'
      }, {
        num: aggregateSaleData.value.totalMoney,
        desc: '总金额/万元'
      }, {
        num: aggregateSaleData.value.totalSingular,
        desc: '总单数/单'
      }, {
        num: aggregateSaleData.value.totalAveragePrice,
        desc: '总均价/元'
      }];
    });
    var tabs = ref(['进料量', '金额']);
    var curTab = ref('进料量');
    var tabClick = function tabClick(val) {
      curTab.value = val;
    };
    var categoryGoodsCount = computed(function () {
      var list = [];
      var unit = '';
      if (curTab.value === '进料量') {
        list = aggregateSaleData.value.settleValueList.map(function (item) {
          return {
            name: item.name,
            value: item.value
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '吨';
      }
      if (curTab.value === '金额') {
        list = aggregateSaleData.value.totMoneyList.map(function (item) {
          return {
            name: item.name,
            value: item.value
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '万元';
      }
      return {
        pieData: list,
        unit: unit,
        customTooltip: true,
        tooltipFormatter: function tooltipFormatter(params) {
          var res = "\n              <div >\n              ";
          if (curTab.value === '进料量') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.value, "\u5428</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          if (curTab.value === '金额') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                       <span style=\"font-size: 12px;\">").concat(params.value, "\u4E07\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    var dayDataTrend = computed(function () {
      var lineData1 = aggregateSaleContrastData.value.map(function (item) {
        return item.net_weight;
      });
      var lineData2 = aggregateSaleContrastData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = aggregateSaleContrastData.value.map(function (item) {
        return item.time;
      });
      var legendData = ['吨数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324'],
        grid: {
          left: 55,
          top: 10,
          bottom: 55,
          right: 35
        },
        legendBottom: 2,
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '吨数' ? '吨' : '万元', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var dayDataTrend1 = computed(function () {
      var lineData1 = aggregateSaleContrastYearData.value.map(function (item) {
        return item.net_weight;
      });
      var lineData2 = aggregateSaleContrastYearData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = aggregateSaleContrastYearData.value.map(function (item) {
        return item.time;
      });
      var legendData = ['吨数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324'],
        grid: {
          left: 55,
          top: 10,
          bottom: 55,
          right: 20
        },
        legendBottom: 2,
        showDetail: true,
        formatter: function formatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '吨数' ? '吨' : '万元', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var title = computed(function () {
      var text = '';
      if (params.value.type === 0) {
        text = '本周对比';
      }
      if (params.value.type === 1) {
        text = '与上周对比';
      }
      if (params.value.type === 2) {
        text = '与上月对比';
      }
      if (params.value.type === 3) {
        text = '与上年对比';
      }
      if (params.value.type === 4) {
        text = '区间对比';
      }
      return text;
    });
    var router = useRouter();
    var toReportDetail = function toReportDetail() {
      router.push({
        name: 'PurchaseReportDetail',
        params: {
          date: params.value.date,
          type: params.value.type,
          reportType: 'mortar' //骨料商砼砂浆  报表类型
        }
      });
    };
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      switchClick: switchClick,
      emptyStringFormat: emptyStringFormat,
      aggregateSaleData: aggregateSaleData,
      summaryData: summaryData,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      categoryGoodsCount: categoryGoodsCount,
      aggregateSaleContrastData: aggregateSaleContrastData,
      title: title,
      toReportDetail: toReportDetail,
      dateRef: dateRef,
      dayDataTrend: dayDataTrend,
      dayDataTrend1: dayDataTrend1
    };
  }
});